<div class="card card-custom">
  <div class="card-header">
    <div class="br-light">
      <button
        type="button"
        style="border-top-left-radius: inherit !important"
        class="border-0 h-100 w-100 skeleton"
      >
        <span
          inlineSVG="assets/media/svg/icons/General/Priority.svg"
          class="svg-icon svg-icon-lg"
        ></span>
      </button>
      <div appearance="standard" class="hidden-field">
        <span
          inlineSVG="assets/media/svg/icons/General/Priority.svg"
          class="svg-icon svg-icon-sm mr-4"
        ></span>
      </div>
    </div>
    <div class="row m-0" style="width: unset !important">
      <div class="col-8 d-flex align-items-center justify-content-between px-15px">
        <div class="d-flex align-items-center">
          <div class="mr-15px skeleton" style="width: 150px; height: 35px">
            <h3 class="m-0 skeleton"></h3>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <button type="button" class="label label-xl label-inline border-0 skeleton"></button>
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-icon btn-light skeleton">
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
          class="svg-icon svg-icon-lg"
          (click)="close($event)"
        ></span>
      </button>
    </div>
  </div>

  <div class="card-body">
    <div class="br-light skeleton"></div>
    <div class="br-light row m-0 skeleton">
      <div class="col-8 var-area br-light skeleton"></div>
      <div class="col-4 scroll p-15px ps skeleton"></div>
      <div class="d-flex flex-column align-items-center py-15px skeleton"></div>
    </div>
  </div>

  <div class="card-footer">
    <div class="tags btn-group dropup">
      <button type="button" class="btn btn-icon-cover btn-circle btn-white symbol skeleton">
        <span
          inlineSVG="assets/media/svg/icons/Files/Tag.svg"
          class="svg-icon svg-icon-light symbol-label"
        ></span>
        <span class="symbol-badge"></span>
      </button>
    </div>
    <div style="justify-content: space-between !important" class="px-15px">
      <div style="display: flex">
        <div class="mr-15px w-16 h-[35px] skeleton" style="width: 119px; height: 35px">
          <div class="font-weight-bolder mr-2"></div>
        </div>
        <div class="mr-15px skeleton" style="width: 119px; height: 35px">
          <div class="font-weight-bolder mr-2"></div>
        </div>
      </div>
      <div>
        <button type="button" class="btn btn-sm btn-light skeleton" (click)="close($event)">
          Cancel
        </button>
        <button type="button" class="btn btn-sm btn-primary ml-15px skeleton">Save</button>
      </div>
    </div>
  </div>
</div>
